"use strict";
import darkStyles from "../src/spectrum-two/theme-dark.css.js";
import { Theme } from "../src/Theme.dev.js";
import "../src/spectrum-two/core.dev.js";
Theme.registerThemeFragment("dark-spectrum-two", "color", darkStyles);
//# sourceMappingURL=theme-dark.dev.js.map
